import { getRandomNum, lastSevenDayData } from "@/utils/index.js";

export function workerData() {
  return [
    {
      name: "支护工",
      id: 428,
      value: 96,
    },
    {
      name: "钢筋工",
      id: 431,
      value: 94,
    },
    {
      name: "开挖工",
      id: 432,
      value: 98,
    },
  ];
}

export function ListData() {
  return [
    {
      name: "张三",
      department: "机械班组",
      position: "支护工",
      id: 428,
      dateTime: "2021-01-01 06:00:00",
      status: "进",
    },
    {
      name: "李四",
      department: "机械班组",
      position: "钢筋工",
      id: 431,
      dateTime: "2021-01-01 10:00:00",
      status: "进",
    },
    {
      name: "王龙",
      department: "机械班组",
      position: "开挖工",
      id: 431,
      dateTime: "2021-01-01 11:00:00",
      status: "进",
    },
    {
      name: "张三",
      department: "机械班组",
      position: "钢筋工",
      id: 431,
      dateTime: "2021-01-01 12:00:00",
      status: "出",
    },
  ];
}

export function StatisticsData() {
  let dataDom = [];

  lastSevenDayData().forEach((itemDate) => {
    dataDom.push({
      date: itemDate.startTime,
      value: getRandomNum(0, 40),
    });
  });

  return dataDom;
}
